<template>
  <div class="transfer-sample-container">
    <div v-if="loading" class="loading-container">
      <el-skeleton :rows="10" animated />
    </div>
    <el-card v-else class="main-card">
      <div class="page-header">
        <div class="title">
          <h2>转寄样品</h2>
        </div>
      </div>

      <el-form :model="transferForm" ref="transferForm" label-width="120px" :rules="transferRules" class="transfer-form" label-position="right">
        <el-divider content-position="left">
          <span class="divider-title">项目信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="订单号" prop="orderNo">
              <el-input v-model="transferForm.orderNo" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单状态">
              <el-tag :type="getStatusType(transferForm.status)" style="width: 100%; text-align: center;">{{ transferForm.status }}</el-tag>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="样品数量">
              <el-input v-model="transferForm.projectInfo.sampleCount" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预期完成时间">
              <el-input v-model="transferForm.projectInfo.expectedCompletionTime" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input 
                type="textarea" 
                v-model="transferForm.projectInfo.remarks" 
                :rows="3"
                disabled
                class="consistent-style">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">
          <span class="divider-title">商家信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="商家名称">
              <el-input v-model="transferForm.originalInfo.merchantName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人">
              <el-input v-model="transferForm.originalInfo.contactPerson" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="联系方式">
              <el-input v-model="transferForm.originalInfo.contactPhone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商家地址">
              <el-input v-model="transferForm.originalInfo.address" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="仪器信息">
              <el-input v-model="transferForm.originalInfo.deviceInfo" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="测试价格">
              <el-input v-model="transferForm.originalInfo.testPrice" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">
          <span class="divider-title">转寄信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="选择商家" prop="newInfo.merchantId">
              <el-select
                v-model="transferForm.newInfo.merchantId"
                filterable
                placeholder="请选择新商家"
                style="width: 100%"
                @change="handleMerchantChange">
                <el-option
                  v-for="item in merchantOptions"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仪器信息" prop="newInfo.deviceId">
              <el-select
                v-model="transferForm.newInfo.deviceId"
                filterable
                placeholder="请选择仪器"
                style="width: 100%"
                @change="handleDeviceChange">
                <el-option
                  v-for="item in deviceOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="参考价格">
              <el-input v-model="transferForm.newInfo.referencePrice" disabled>
                <template slot="prepend">¥</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实际价格" prop="newInfo.actualPrice">
              <el-input v-model="transferForm.newInfo.actualPrice">
                <template slot="prepend">¥</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="联系人">
              <el-input v-model="transferForm.newInfo.contactPerson" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式">
              <el-input v-model="transferForm.newInfo.contactPhone" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="商家地址">
              <el-input v-model="transferForm.newInfo.address" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="转寄原因" prop="reason">
              <el-input 
                type="textarea" 
                v-model="transferForm.reason" 
                :rows="3"
                placeholder="请输入转寄原因"
                class="consistent-style">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">
          <span class="divider-title">物流信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="快递公司" prop="logistics.company">
              <el-select v-model="transferForm.logistics.company" placeholder="请选择快递公司" style="width: 100%">
                <el-option
                  v-for="item in logisticsOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="快递单号" prop="logistics.trackingNo">
              <el-input v-model="transferForm.logistics.trackingNo" placeholder="请输入快递单号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="转寄时间" prop="logistics.shipTime">
              <el-date-picker
                v-model="transferForm.logistics.shipTime"
                type="datetime"
                placeholder="选择转寄时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        
        <div class="form-footer">
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="goBack">取消</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'TransferSample',
  data() {
    return {
      loading: true,
      orderId: '',
      orderSn: '',
      logisticsOptions: [],
      merchantOptions: [],
      deviceOptions: [],
      merchantData: {},
      transferForm: {
        orderNo: '',
        status: '',
        reason: '',
        projectInfo: {
          sampleCount: 1,
          expectedCompletionTime: '',
          remarks: ''
        },
        originalInfo: {
          merchantName: '',
          contactPerson: '',
          contactPhone: '',
          address: '',
          deviceInfo: '',
          testPrice: ''
        },
        newInfo: {
          merchantId: '',
          merchantName: '',
          deviceId: '',
          deviceName: '',
          referencePrice: '',
          actualPrice: '',
          contactPerson: '',
          contactPhone: '',
          address: ''
        },
        logistics: {
          company: '',
          trackingNo: '',
          shipTime: ''
        },
        remark: ''
      },
      transferRules: {
        reason: [{ required: true, message: '请输入转寄原因', trigger: 'blur' }],
        'newInfo.merchantId': [{ required: true, message: '请选择新商家', trigger: 'change' }],
        'newInfo.deviceId': [{ required: true, message: '请选择仪器', trigger: 'change' }],
        'newInfo.actualPrice': [{ required: true, message: '请输入实际价格', trigger: 'blur' }],
        'logistics.company': [{ required: true, message: '请选择快递公司', trigger: 'change' }],
        'logistics.trackingNo': [{ required: true, message: '请输入快递单号', trigger: 'blur' }],
        'logistics.shipTime': [{ required: true, message: '请选择转寄时间', trigger: 'change' }]
      }
    }
  },
  created() {
    // 从路由获取订单ID
    this.orderId = this.$route.params.id
    
    if (this.orderId) {
      this.loading = true
      // 获取订单信息
      this.fetchOrderInfo()
      // 获取商家列表
      this.fetchMerchantList()
      // 获取物流公司列表
      this.fetchLogisticsList()
    } else {
      this.$message.error('没有找到订单信息')
      this.goBack()
    }
  },
  methods: {
    // 获取订单状态对应的类型
    getStatusType(status) {
      const typeMap = {
        '未邮寄': 'info',
        '已邮寄': 'warning',
        '测试中': 'primary',
        '已完成': 'success',
        '已取消': 'danger'
      }
      return typeMap[status] || 'info'
    },
    
    // 订单状态映射
    mapOrderStatus(status) {
      const statusMap = {
        'NOT_SHIPPED': '未邮寄',
        'SHIPPED': '已邮寄',
        'IN_TRANSIT': '运输中',
        'TESTING': '测试中',
        'COMPLETED': '已完成',
        'CANCELED': '已取消'
      }
      return statusMap[status] || status
    },
    
    async fetchMerchantList() {
      try {
        const res = await adminApi.getMerchantList()
        
        if (res && Array.isArray(res)) {
          this.merchantOptions = res
          
          // 构建商家数据查找表，用于仪器列表和价格信息
          this.merchantData = {};
          res.forEach(item => {
            this.merchantData[item.id] = {
              contact: item.contactPerson || '',
              phone: item.phone || item.contactPhone || '',
              address: item.address || '',
              equipment: (item.deviceInfoList || []).map(device => ({
                value: device.id.toString(),
                label: device.deviceName,
                referencePrice: device.price || '0.00',
                actualPrice: device.price || '0.00'
              }))
            };
          });
          
          console.log('商家数据初始化完成:', this.merchantData)
        } else {
          this.merchantOptions = []
          this.$message.warning('获取商家列表失败')
        }
      } catch (error) {
        this.merchantOptions = []
        this.$message.error('获取商家列表失败: ' + (error.message || '未知错误'))
      } finally {
        this.loading = false
      }
    },
    async fetchOrderInfo() {
      try {
        // 获取订单信息
        const res = await adminApi.getOrderById(this.orderId)
        
        if (res) {
          const orderData = res
          this.orderSn = orderData.orderSn
          
          // 获取当前时间作为转寄时间
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, '0');
          const day = String(now.getDate()).padStart(2, '0');
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          const seconds = String(now.getSeconds()).padStart(2, '0');
          const currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
          
          // 填充表单基本信息
          this.transferForm = {
            orderNo: orderData.orderSn,
            status: this.mapOrderStatus(orderData.orderStatus) || '未邮寄',
            reason: '',
            projectInfo: {
              sampleCount: orderData.testCount || 1,
              expectedCompletionTime: orderData.expectedEndTime || '',
              remarks: orderData.remarks || ''
            },
            originalInfo: {
              merchantName: orderData.merchantName || '',
              contactPerson: orderData.merchantPerson || '',
              contactPhone: orderData.merchantPhone || '',
              address: orderData.merchantAddress || '',
              deviceInfo: orderData.deviceName || '',
              testPrice: orderData.actualPrice || ''
            },
            newInfo: {
              merchantId: '',
              merchantName: '',
              deviceId: '',
              deviceName: '',
              referencePrice: '',
              actualPrice: '',
              contactPerson: '',
              contactPhone: '',
              address: ''
            },
            logistics: {
              company: '',
              trackingNo: '',
              shipTime: currentTime // 设置转寄时间为当前时间
            },
            remark: ''
          }

          console.log('订单数据:', orderData);
          console.log('转寄表单数据:', this.transferForm);
        } else {
          this.$message.error(res.data ? res.data.msg : '获取订单信息失败')
          this.goBack()
        }
      } catch (error) {
        this.$message.error('获取订单信息失败: ' + (error.message || '未知错误'))
        this.goBack()
      }
    },
    handleMerchantChange(merchantId) {
      // 当选择新商家时更新商家信息和仪器列表
      const selectedMerchant = this.merchantOptions.find(item => item.id === merchantId)
      if (selectedMerchant) {
        // 更新商家基本信息
        this.transferForm.newInfo.merchantName = selectedMerchant.companyName
        this.transferForm.newInfo.contactPerson = selectedMerchant.contactPerson || ''
        this.transferForm.newInfo.contactPhone = selectedMerchant.phone || selectedMerchant.contactPhone || ''
        this.transferForm.newInfo.address = selectedMerchant.address || ''
        
        // 清空仪器和价格信息
        this.transferForm.newInfo.deviceId = ''
        this.transferForm.newInfo.deviceName = ''
        this.transferForm.newInfo.referencePrice = ''
        this.transferForm.newInfo.actualPrice = ''
        
        // 更新仪器选项
        if (this.merchantData[merchantId]) {
          this.deviceOptions = this.merchantData[merchantId].equipment || []
          
          // 如果原来的信息不完整，从merchantData补充
          if (!this.transferForm.newInfo.contactPerson && this.merchantData[merchantId].contact) {
            this.transferForm.newInfo.contactPerson = this.merchantData[merchantId].contact
          }
          
          if (!this.transferForm.newInfo.contactPhone && this.merchantData[merchantId].phone) {
            this.transferForm.newInfo.contactPhone = this.merchantData[merchantId].phone
          }
          
          if (!this.transferForm.newInfo.address && this.merchantData[merchantId].address) {
            this.transferForm.newInfo.address = this.merchantData[merchantId].address
          }
        } else {
          this.deviceOptions = []
        }
        
        console.log('选择商家后更新的表单数据:', this.transferForm.newInfo)
      }
    },
    handleDeviceChange(deviceId) {
      // 根据选择的仪器更新价格信息
      if (this.transferForm.newInfo.merchantId && deviceId) {
        const merchantEquipment = this.merchantData[this.transferForm.newInfo.merchantId]?.equipment || []
        const selectedDevice = merchantEquipment.find(item => item.value === deviceId)
        
        if (selectedDevice) {
          // 设置仪器名称
          this.transferForm.newInfo.deviceName = selectedDevice.label
          
          // 计算参考价格和实际价格（乘以样品数量）
          const basePrice = parseFloat(selectedDevice.referencePrice) || 0
          const sampleCount = parseInt(this.transferForm.projectInfo.sampleCount) || 1
          const totalPrice = basePrice * sampleCount
          
          this.transferForm.newInfo.referencePrice = totalPrice.toFixed(2)
          this.transferForm.newInfo.actualPrice = totalPrice.toFixed(2)
        }
      }
    },
    submitForm() {
      this.$refs.transferForm.validate(async valid => {
        if (valid) {
          // 检查选择的新商家是否与原商家相同
          if (this.transferForm.newInfo.merchantName === this.transferForm.originalInfo.merchantName) {
            this.$message.warning('新选择的商家与原商家相同，请选择不同的商家')
            return
          }
          
          try {
            this.$loading({
              lock: true,
              text: '提交转寄申请...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            
            // 构造提交数据
            const submitData = {
              orderSn: this.transferForm.orderNo,
              // 转寄为2
              isReturnForward: 2,
              reason: this.transferForm.reason,
              remark: this.transferForm.remark,
              
              // 目标商家信息
              targetMerchantId: this.transferForm.newInfo.merchantId,
              targetMerchantName: this.transferForm.newInfo.merchantName,
              targetMerchantPerson: this.transferForm.newInfo.contactPerson,
              targetMerchantPhone: this.transferForm.newInfo.contactPhone,
              targetMerchantAddress: this.transferForm.newInfo.address,
              
              // 仪器信息和价格
              targetDeviceId: this.transferForm.newInfo.deviceId,
              targetDeviceName: this.transferForm.newInfo.deviceName,
              targetReferencePrice: this.transferForm.newInfo.referencePrice,
              targetActualPrice: this.transferForm.newInfo.actualPrice,
              
              // 物流信息
              trackSn: this.transferForm.logistics.trackingNo,
              trackName: this.getTrackCompanyName(this.transferForm.logistics.company),
              returnForwardTime: this.transferForm.logistics.shipTime
            }
            
            // 提交转寄样品请求
            const res = await adminApi.forwardSample(submitData)
            
            this.$loading().close()
            
            if (res) {
              this.$message({
                message: '转寄样品申请提交成功',
                type: 'success'
              })
              
              // 返回订单列表
              setTimeout(() => {
                this.goBack()
              }, 1500)
            }
          } catch (error) {
            this.$loading().close()
            this.$message.error('提交失败: ' + (error.message || '未知错误'))
          }
        }
      })
    },
    
    // 根据快递公司代码获取快递公司名称
    getTrackCompanyName(code) {
      const company = this.logisticsOptions.find(item => item.value === code)
      return company ? company.label : code
    },
    
    goBack() {
      this.$router.go(-1)
    },
    async fetchLogisticsList() {
      try {
        const res = await adminApi.getLogisticsList()
        if (res && Array.isArray(res)) {
          // 转换为select需要的格式
          this.logisticsOptions = res.map(item => ({
            value: item.trackCode,
            label: item.trackName
          }))
        } else {
          this.$message.warning('获取物流公司列表失败')
        }
      } catch (error) {
        console.error('获取物流公司列表错误:', error)
        this.$message.error('获取物流公司列表失败: ' + (error.message || '未知错误'))
      }
    }
  }
}
</script>

<style scoped>
.transfer-sample-container {
  padding: 30px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.loading-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.main-card {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.page-header {
  margin-bottom: 30px;
}

.title {
  display: flex;
  flex-direction: column;
}

.title h2 {
  margin-top: 0;
  margin-bottom: 10px;
  text-align: left;
}

.divider-title {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
  position: relative;
  padding-left: 12px;
}

.divider-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 18px;
  width: 4px;
  background-color: #409EFF;
  border-radius: 2px;
}

.transfer-form {
  max-width: 100%;
}

.el-form-item {
  margin-bottom: 24px;
}

.el-form-item__label {
  font-weight: bold;
  color: #606266;
  white-space: nowrap;
  padding-right: 10px;
}

.form-footer {
  margin-top: 40px;
  text-align: center;
}

.form-footer .el-button {
  min-width: 120px;
  margin: 0 10px;
}

.el-textarea.consistent-style /deep/ .el-textarea__inner {
  font-family: inherit;
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
}

.el-input.consistent-style /deep/ .el-input__inner {
  font-family: inherit;
  font-size: 14px;
  color: #606266;
}

/* 确保disabled状态的输入框也保持一致的样式 */
.el-input.is-disabled /deep/ .el-input__inner,
.el-textarea.is-disabled /deep/ .el-textarea__inner {
  color: #606266;
  background-color: #f5f7fa;
}
</style> 